<template>
    <div class="service ">
      <div class="container page_banner">
          <div class='page_width'>
           <div class="banner_gruop" v-animate="'animate__animated animate__slideInDown'">
              <div class="banner_title">Contact Us</div>
            
           </div>
          </div>
        </div>
    
        <div class="container contact_full"> 
            <div class="page_width">
                <div class="page_thumb">
                    <div class="page_container cate_container">
                        <div class="grid grid_md_gap grid_xs_gap grid_gap_none">
                            <div class="grid_md_6 grid_xs_12 grid_sm_12" >  
                                <div class="thumb_group ">
                                    <div class="thumb_title color3">Request a Callback</div>
                                    <div class="thumb_tag">We deeply appreciate your input and are dedicated to supporting you with any inquiries or issues related to our games. Feel free to reach out to us via the email provided below.</div>
                                    <div class="card_group ">
                                        
                                        <div class="card_info flex">
                                            <div class="el-icon-location-information card_icon flex_center"></div>
                                            <div class="info_title">ADDRESS:</div>
            
                                        </div>
                                        <div class="info_text">14509 Bowcreek Ln Chino Hills, CA 91709 United States</div>
                                    </div>
                                    
                                    <div class="card_group ">
                                        
                                        <div class="card_info flex">
                                            <div class="el-icon-message card_icon"></div>
                                            <div class="info_title">OFFICE EMAIL:</div>
                                            
                                        </div>
                                        <div class="info_text">support@futurelastertech.com</div>
                                    </div>
                                </div>
                            </div>
                        <div class="grid_md_6 grid_xs_12 grid_sm_12">
                            
                            <div class="thumb_group">    
                                <div class="input_gruop ">
                                    <div class="input_label"><i class="el-icon-s-custom"></i> NAME</div>
                                    <div class="input_content">
                                        <el-input placeholder="Your Name"  v-model="name"></el-input>
                                    </div>
                                    <div class="input_label"><i class="el-icon-message"></i> EMAIL</div>
                                    <div class="input_content">
                                        <el-input placeholder="Email"  v-model="email"></el-input>
                                    </div>
                                </div>
                                <!-- <div class="input_gruop flex_sb">
                                    <div class="input_content">
                                        <el-input placeholder="Phone" suffix-icon="el-icon-phone" v-model="phone"></el-input>
                                    </div>
                                    <div class="input_content">
                                        <el-select v-model="subjict" placeholder="Subjict">
                                            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                        </el-select>
                                  
                                    </div>
                                </div> -->
                                <div class="input_gruop">
                                    <div class="input_label"><i class="el-icon-edit-outline"></i> MESSAGE</div>
                                    <div class="input_content " style="width: 100%;">
                                        <el-input type="textarea" :rows="6" placeholder="Write Message..."  v-model="textarea"></el-input>
                                    </div>
                                </div>
                                
                            </div>
                            <div class="btn"><span class="bg_btn pointer">Send Message</span></div>
                        </div>
                        
                    
                    </div>
                </div>
                
                </div>
            </div>
        </div>
        
  
  
    </div>
  </template>
  
  <script>
  
  export default {
    data(){
        return{
            name:'',
            email:'',
            phone:'',
            subjict:'',
            textarea:'',
            options:[
                {value:'Subject',label:'Subject'},
                {value:'Esports',label:'Esports'},
                {value:'Tournament',label:'Tournament'},
                {value:'Sports',label:'Sports'},
            ]
        }
    },
    methods:{
       goTop(e){
        document.querySelector(e).scrollIntoView(true);
      }
    },
    created(){
     
    }
  
  }
  </script>
  
  <style scoped lang="scss">
  .contact_full{
    // background-image:url(../../../public/bg/bg_21.png);
    // background-position: center center;
    // background-repeat: no-repeat;
    // background-size: cover;
   
    .cate_container{
        padding:40px 12px 0;
    }
    .page_thumb{
        
        text-align: left;
        .thumb_tag{
            // color:#849188;
            
            font-size: 14px;
           
            text-align: left;
            margin:0px auto 0;
            line-height: 1.5;
            font-weight: 300;
        }
        .thumb_title{
           
            // margin-bottom:40px;
            font-size: 26px;
            text-align: center;
            margin:0 auto 20px;
            width:80%;
        }
        .btn{
            >span{
                padding:10px 30px;
                color:$theme_color4;    
            }
            margin-bottom:50px;
        }
        .thumb_group{
            padding:50px 0 20px;
            .input_gruop{
                margin-bottom:40px;
                .input_label{
                    margin-bottom:10px;
                }
                .input_content{
                    width: 100%;
                    margin-bottom:40px;
                    // padding:0 12px;
                    &:first-child{
                        padding-left:0;
                    }
                    &:last-child{
                        padding-right: 0;
                    }
                    /deep/ .el-input__inner{
                        background: transparent;
                        height: 60px;
                        border:1px solid $theme_color3;
                        
                        font-size: 18px;
                        color:$theme_color1;
                    }
                    /deep/ .el-textarea__inner{
                        border:1px solid $theme_color3;
                       
                        font-size: 18px;
                        background:  transparent;
                        color:$theme_color1;
                    }
                    .el-textarea{
                        background:transparent;
                    }
                    /deep/ .el-select-dropdown{
                        // border:1px solid $theme_color3;
                       
                        font-size: 18px;
                        // background: $theme_bg;
                    }
                }
            }
            .card_group{

                padding:20px 0;
                position: relative;
                margin-top:50px;
              
               
                .card_icon{
                    font-size: 60px;
                    margin-right:20px;
                    color:$theme_color1;
                }
                .card_info{
                    .info_title{
                        font-size: 30px;
                        color:$theme_color3;
                        line-height: 60px;
                    }
                    
                }
                .info_text{
                    font-family: PingFang SC, PingFang SC;
                    margin-top:10px;
                    color:$theme_color1;
                    font-weight: 500;
                }
            }
            
        }
    }
   
  }
  @media screen and (max-width:767px) {
    .thumb_title{
        font-size: 20px!important;
        width:100%!important;
    }
    .info_text{
        font-size: 14px!important;
    }
    .thumb_tag{
        width:100%!important;
        font-size: 16px!important;
    }
 } 
  </style>